import {
  IconCalendarEvent,
  IconCalendarQuestion,
  IconCategory2,
  IconChefHat,
  IconUsers,
  IconAd,
  IconPalette,
  IconSpeakerphone,
  IconRss,
  IconNews,
} from "@tabler/icons-react";
import classes from "./NavbarSimple.module.css";
import { Link, useLocation } from "react-router-dom";
import { IconBuildingWarehouse } from "@tabler/icons-react";
import { useQueryCurrentUser } from "hooks/users";
import { useAppTranslation } from "hooks/useTranslation";

const adminMenu = [
  { link: "/desk", labelKey: "navigation.desk", icon: IconNews },
  {
    link: "/applications",
    labelKey: "navigation.applications",
    icon: IconCalendarQuestion,
  },
  { link: "/beats", labelKey: "navigation.beats", icon: IconRss },
  {
    link: "/events",
    labelKey: "navigation.events",
    icon: IconCalendarEvent,
  },
  { link: "/organizers", labelKey: "navigation.organizers", icon: IconChefHat },
  {
    link: "/venues",
    labelKey: "navigation.venues",
    icon: IconBuildingWarehouse,
  },
  { link: "/users", labelKey: "navigation.users", icon: IconUsers },
  { separator: true },
  { link: "/advertisers", labelKey: "navigation.advertisers", icon: IconAd },
  { link: "/creatives", labelKey: "navigation.creatives", icon: IconPalette },
  { link: "/campaigns", labelKey: "navigation.campaigns", icon: IconSpeakerphone },
];

const organizerMenu = [
  {
    link: "/events",
    labelKey: "navigation.events",
    icon: IconCalendarEvent,
  },
  {
    link: "/profile",
    labelKey: "navigation.organizer",
    icon: IconCategory2,
  },
];
interface NavBarProps {
  active: string;
}

export function NavBar(props: NavBarProps) {
  const { user } = useQueryCurrentUser();
  const path = useLocation();
  const { t } = useAppTranslation();

  if (!user) return null; // Return nothing if no user is logged in

  const links = (user?.organizer_id === null ? adminMenu : organizerMenu).map(
    (item, index) => {
      if ("separator" in item) {
        return (
          <hr
            key={`separator-${index}`}
            style={{ borderColor: "#dee2e6", margin: "16px 0" }}
          />
        );
      }
      return (
        <Link
          className={classes.link}
          data-active={item.link === path.pathname || undefined}
          to={item.link}
          key={item.labelKey}
        >
          <item.icon className={classes.linkIcon} stroke={1.5} />
          <span>{t(item.labelKey)}</span>
        </Link>
      );
    }
  );

  return <div className={classes.navbarMain}>{links}</div>;
}
